import PropTypes from 'prop-types';

import { Column } from '../display';

import Checkbox from './Checkbox';
import TextInput from './TextInput';

// Opt-in note appended to the credential email sent by the backend.
// Prefills with defaultNote (placeholder line + sender name) when first enabled.
function EmailNoteField(props) {
  const {
    checked,
    onCheckedChange,
    note,
    onNoteChange,
    defaultNote,
    translate,
  } = props;

  const handleToggle = (event) => {
    const next = event.currentTarget.value;
    onCheckedChange(next);
    if (next && (!note?.length)) onNoteChange(defaultNote);
  };

  const handleNote = (event) => {
    onNoteChange(event.currentTarget.value);
  };

  return (
    <Column crossStart gap={2} className="w-full">
      <Checkbox
        checked={checked}
        onChange={handleToggle}
        label={translate('addNoteToEmail', 'statements')}
      />

      {(checked)
        ? (
            <TextInput
              multiline
              fullWidth
              value={note}
              onChange={handleNote}
              className="min-h-[90px]"
            />
          )
        : null}
    </Column>
  );
}

EmailNoteField.propTypes = {
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func.isRequired,
  note: PropTypes.string,
  onNoteChange: PropTypes.func.isRequired,
  defaultNote: PropTypes.string,
  translate: PropTypes.func.isRequired,
};

export default EmailNoteField;
